import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import T from 'i18n-react'
import { TEST_RESULT } from 'containers/Greenlight/constants'
import { Flex } from 'reflexbox'
import Body2 from 'components/typography/body2/index'
import Body from 'components/typography/body1/index'
import StatusIcon from 'components/display/StatusIcon'

const FailureInfo = (props) => {
  if(props.result === TEST_RESULT.FAIL){
    return (
      <Flex align='center' styleName='container'>
        <StatusIcon color='accent' iconName='clear' />
        <div styleName='text'>
          <Body2>
            {
              T.translate(`finalReport.tests.${props.name}`)
            }
            {
              T.translate('testReport.failureHeader')
            }
          </Body2>
          <ul>
            {props.reasons.map((reason, index) => {
              return (
                <li key={index}><Body>{reason}</Body></li>
              )
            })}
          </ul>
        </div>
      </Flex>
    )
  } else {
    return null
  }
}

export default CSSModules(styles)(FailureInfo)
